import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
var _excluded = ["type", "icon", "isClearable", "loading", "onClearClicked", "className"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classNames from 'classnames';
// @TODO: replace this with something else, this package hasn't been touched since 2018
import MaskedInput from 'react-text-mask';
import omit from 'lodash/omit';
import { Field } from '@lmig/lmds-react-field';
import { IconButton, IconClose } from '@lmig/lmds-react-icons';
import { LoadingSpinner } from '@lmig/lmds-react-loading-spinner';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import "./alphanumericInput.css";
var instance = 0;

// @TODO consider refactoring it into a function component to show the default in the Storybook props table.
export var AlphanumericInput = /*#__PURE__*/function (_React$Component) {
  _inherits(AlphanumericInput, _React$Component);
  var _super = _createSuper(AlphanumericInput);
  function AlphanumericInput(props) {
    var _this;
    _classCallCheck(this, AlphanumericInput);
    _this = _super.call(this, props);
    if (!props.id) instance++;
    _this.state = {
      isFocused: false,
      isPopulated: !!props.value,
      placeholder: '',
      value: props.value,
      uniqueId: props.id || "alphaNumericInput".concat(instance)
    };
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.getConcealedValue = _this.getConcealedValue.bind(_assertThisInitialized(_this));
    _this.asteriskPipe = _this.asteriskPipe.bind(_assertThisInitialized(_this));
    _this.renderInput = _this.renderInput.bind(_assertThisInitialized(_this));
    _this.renderActionButtons = _this.renderActionButtons.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(AlphanumericInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var filter = this.props.filter;
      var uniqueId = this.state.uniqueId;
      if (filter && uniqueId) {
        AlphanumericInput.setInputFilter(document.getElementById("".concat(uniqueId, "-input")), function (value) {
          return filter.test(value);
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var propValue = this.props.value;
      var stateValue = this.state.value;
      if (propValue !== prevProps.value) {
        // Internal state needs to be updated when a new value has been given and
        //   component re-renders. See: https://github.com/airbnb/javascript/issues/1875
        //   regarding linting rule disable.
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isPopulated: !!propValue,
          value: propValue
        });
      }
      if (stateValue === "".concat(AlphanumericInput.concealTrigger).concat(prevState.value)) {
        // Remove the conceal trigger after it has been inserted.
        var regex = new RegExp(AlphanumericInput.concealTrigger, 'g');
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          value: stateValue.replace(regex, '')
        });
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      var _this$props = this.props,
        onFocus = _this$props.onFocus,
        placeholder = _this$props.placeholder,
        mask = _this$props.mask;
      var maskPlaceholder = mask && !placeholder ? AlphanumericInput.masks[mask].placeholder : placeholder;
      this.setState({
        isFocused: true,
        placeholder: maskPlaceholder
      });
      if (onFocus) {
        onFocus(e);
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var _this$props2 = this.props,
        conceal = _this$props2.conceal,
        mask = _this$props2.mask,
        onBlur = _this$props2.onBlur;
      this.setState(function (prevState) {
        return {
          isFocused: false,
          // Insert trigger character to initiate concealing.
          value: (mask || conceal) && prevState.value ? "".concat(AlphanumericInput.concealTrigger).concat(prevState.value) : prevState.value,
          placeholder: ''
        };
      });
      if (onBlur) {
        onBlur(e);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var onChange = this.props.onChange;
      var newValue = e.target.value;
      this.setState({
        isPopulated: !!newValue,
        value: newValue
      });
      if (onChange) {
        onChange(e);
      }
    }
  }, {
    key: "getConcealedValue",
    value: function getConcealedValue(value) {
      var _this$props3 = this.props,
        conceal = _this$props3.conceal,
        mask = _this$props3.mask;
      var maskConceal = mask && AlphanumericInput.masks[mask].concealed;
      var concealedValue = '';
      if (value) {
        switch (conceal) {
          case 'none':
            concealedValue = value;
            break;
          case 'all':
            concealedValue = maskConceal || "".concat(value.replace(/[a-zA-Z0-9]/g, '*'));
            break;
          case 'allButLastFour':
            concealedValue = maskConceal ? "".concat(maskConceal.slice(0, -4)).concat(value.slice(maskConceal.length - 4)) : "".concat(value.slice(0, -4).replace(/[a-zA-Z0-9]/g, '*')).concat(value.slice(-4));
            break;
          case 'lastFour':
            concealedValue = maskConceal ? "".concat(value.slice(0, -4)).concat(maskConceal.slice(-4)) : "".concat(value.slice(0, -4)).concat(value.slice(-4).replace(/[a-zA-Z0-9]/g, '*'));
            break;
          case 'email':
            {
              var domain = value.split('@')[1];
              var suffix = domain ? "@".concat(domain) : '';
              concealedValue = maskConceal || "****".concat(suffix);
              break;
            }
          default:
            switch (mask) {
              case 'ssn':
              case 'ssnToken':
              case 'creditCard':
                concealedValue = "".concat(maskConceal.slice(0, -4)).concat(value.slice(maskConceal.length - 4));
                break;
              case 'ssnLastFour':
              case 'cvc':
                concealedValue = maskConceal;
                break;
              default:
                concealedValue = value;
            }
        }
      }
      // It's okay for a concealed email to be longer than the original email. Example: hi@foo.com --> ****@foo.com
      if (conceal !== 'email' && value.length < concealedValue.length) {
        concealedValue = concealedValue.substring(0, value.length);
      }
      return concealedValue;
    }
  }, {
    key: "scaledIcon",
    value: function scaledIcon() {
      var icon = this.props.icon;
      return /*#__PURE__*/React.cloneElement(icon, {
        size: '16'
      });
    }
  }, {
    key: "asteriskPipe",
    value: function asteriskPipe(conformedValue) {
      var isFocused = this.state.isFocused;
      return isFocused ? conformedValue : this.getConcealedValue(conformedValue);
    }
  }, {
    key: "renderInput",
    value: function renderInput(inputProps) {
      var _this$props4 = this.props,
        className = _this$props4.className,
        mask = _this$props4.mask,
        conceal = _this$props4.conceal,
        innerRef = _this$props4.innerRef;
      var _this$state = this.state,
        placeholder = _this$state.placeholder,
        value = _this$state.value,
        uniqueId = _this$state.uniqueId;
      if (mask || conceal) {
        return /*#__PURE__*/React.createElement(MaskedInput, _extends({
          id: "".concat(uniqueId, "-input"),
          value: value,
          mask: mask ? AlphanumericInput.masks[mask].mask : function (rawValue) {
            return rawValue.split('').map(function () {
              return /./;
            });
          },
          placeholderChar: "\u2000",
          placeholder: placeholder,
          pipe: this.asteriskPipe,
          guide: false,
          className: classNames('lm-Field-input', className),
          "aria-labelledby": "".concat(uniqueId, "-input-label"),
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onChange: this.onChange,
          render: function render(maskInputRef, props) {
            return /*#__PURE__*/React.createElement("input", _extends({}, props, {
              ref: function ref(inputElement) {
                maskInputRef(inputElement); // let maskedinput set its own ref
                if (innerRef && inputElement) {
                  // @TODO look into fixing the error instead of using ts-ignore, see https://forge.lmig.com/issues/browse/USCMUDS-637
                  // eslint-disable-next-line
                  // @ts-ignore
                  innerRef.current = inputElement; // also set our inputRef

                  // Used if the innerRef is a callback ref
                  if (typeof innerRef === 'function') {
                    innerRef(inputElement);
                  }

                  // @TODO look into fixing the error instead of using ts-ignore, see https://forge.lmig.com/issues/browse/USCMUDS-637
                  // eslint-disable-next-line
                  // @ts-ignore
                  innerRef.current.inputElement = inputElement; // and set the legacy inputElement field (to deprecate)
                }
              }
            }));
          }
        }, inputProps));
      }
      return /*#__PURE__*/React.createElement("input", _extends({
        id: "".concat(uniqueId, "-input"),
        value: value,
        className: classNames('lm-Field-input', className),
        placeholder: placeholder,
        "aria-labelledby": "".concat(uniqueId, "-input-label"),
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onChange: this.onChange,
        ref: innerRef
      }, inputProps));
    }
  }, {
    key: "renderActionButtons",
    value: function renderActionButtons() {
      var children = this.props.children;
      if (!children) {
        return null;
      }
      return /*#__PURE__*/React.createElement("span", {
        className: "lm-Field-actionButton"
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        type = _this$props5.type,
        icon = _this$props5.icon,
        _this$props5$isCleara = _this$props5.isClearable,
        isClearable = _this$props5$isCleara === void 0 ? false : _this$props5$isCleara,
        _this$props5$loading = _this$props5.loading,
        loading = _this$props5$loading === void 0 ? false : _this$props5$loading,
        onClearClicked = _this$props5.onClearClicked,
        className = _this$props5.className,
        newProps = _objectWithoutProperties(_this$props5, _excluded);
      var _this$state2 = this.state,
        uniqueId = _this$state2.uniqueId,
        isFocused = _this$state2.isFocused,
        isPopulated = _this$state2.isPopulated,
        value = _this$state2.value;
      // Destructuring `disabled` separately to ensure that it's included in `newProps`
      var disabled = this.props.disabled;
      var fieldProps = omit(newProps, ['value', 'conceal']);
      var inputProps = omit(this.props, ['className', 'id', 'value', 'labelVisual', 'labelA11y', 'helpText', 'highlightType', 'mask', 'conceal', 'icon', 'isClearable', 'loading', 'filter', 'placeholder', 'onChange', 'onFocus', 'onBlur', 'onClearClicked', 'innerRef', 'children']);
      var isEnabledAndClearable = !disabled && isClearable;

      // Should onChange be included here so consumers know to only use this as a controlled component?
      if (isEnabledAndClearable && !onClearClicked && process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('The Clear Button is shown, but there is no function currently attached to it. Please pass a function to the `onClearClicked` prop to handle Clear Button functionality.');
      }
      return /*#__PURE__*/React.createElement(Field, _extends({
        className: classNames({
          'lmig-Field-input--hasIcon': icon,
          'lmig-Field-input--isClearable': isEnabledAndClearable
        }, className)
      }, fieldProps, {
        value: value,
        isFocused: isFocused,
        isForceFloat: type === 'date' || type === 'datetime-local' || type === 'month' || type === 'week' || type === 'time',
        isPopulated: isPopulated,
        type: type === 'hidden' ? 'hidden' : 'alphanumeric',
        labelId: uniqueId
      }), this.renderInput(inputProps), this.renderActionButtons(), icon && /*#__PURE__*/React.createElement("span", {
        className: "lm-Field-input-icon"
      }, this.scaledIcon()), isEnabledAndClearable && !loading && /*#__PURE__*/React.createElement(IconButton, {
        className: "lm-Field-input-clear",
        onClick: onClearClicked,
        background: "transparent"
      }, /*#__PURE__*/React.createElement(IconClose, {
        size: "16",
        title: "Clear"
      })), loading && /*#__PURE__*/React.createElement(LoadingSpinner, {
        className: "lm-Field-input-loading",
        size: "16",
        color: "blue",
        hiddenTrack: true
      }));
    }
  }], [{
    key: "setInputFilter",
    value: function setInputFilter(textbox, inputFilter) {
      ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
        if (textbox) {
          textbox.addEventListener(event, function listen() {
            if (inputFilter(this.value) || this.value === '') {
              this.oldValue = this.value;
              this.oldSelectionStart = this.selectionStart;
              this.oldSelectionEnd = this.selectionEnd;
            } else if (Object.prototype.hasOwnProperty.call(this, 'oldValue')) {
              this.value = this.oldValue;
              if (this.oldSelectionStart && this.oldSelectionEnd) {
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
              }
            }
          });
        }
      });
    }
  }]);
  return AlphanumericInput;
}(React.Component);
_defineProperty(AlphanumericInput, "propTypes", {
  /** Add an optional ID to this element: `<input className="lm-Field-input">`. */id: _pt.string,
  /** Add custom classes to this element: `<input className="lm-Field-input">`. */className: _pt.string,
  /** Used for POST and GET if using the browser’s native form submission functionality. */name: _pt.string,
  /** The value that displays in the input field. If using a masked field type, a raw value is acceptable. */value: _pt.string,
  /** In most cases, you will want to use 'text', even for date and number-based fields.
     * @default 'text'
     */
  type: _pt.oneOf(['date', 'datetime-local', 'email', 'hidden', 'month', 'number', 'password', 'search', 'tel', 'text', 'time', 'url', 'week']),
  /** Block users from interacting with this field.
     * @default false
     */
  disabled: _pt.bool,
  /** The text that appears inside the input field and becomes a floating label when focused. */labelVisual: _pt.node.isRequired,
  /** Used with screen readers, optional?: this text will replace the labelVisual in audio guidance. */labelA11y: _pt.node,
  /** Additional text to display near the field. */helpText: _pt.node,
  /** Apply situational colors and behaviors to this element. */highlightType: _pt.oneOf(['error']),
  /** If using a mask, you can optionally specify how the text is concealed.
     * By default (i.e., when value is undefined) the most common concealment for the given mask type will be used.
     * Remove concealing by using the 'none' value. */
  conceal: _pt.oneOf(['all', 'allButLastFour', 'email', 'lastFour', 'none']),
  /** Pass a regular expression to prevent entry of specific characters, by default all characters are allowed.
     * @default .*
     */
  filter: _pt.instanceOf(RegExp),
  /* Add placeholder text to be displayed on focus. If using a mask, this will override the default mask placeholder. */placeholder: _pt.string,
  /** Whether the input can be cleared. If true, this will display an IconClose button on the right side of the input field.
     * @default false
     */
  isClearable: _pt.bool,
  /** Add an icon to display on the left hand side of the component. */icon: _pt.element,
  /** Whether the component is in a loading state.
     * @default false
     */
  loading: _pt.bool,
  /** Pass additional functionality to run on onKeyDown events. */onKeyDown: _pt.func,
  /** Pass additional functionality to run on click events. */onClick: _pt.func,
  /** Pass additional functionality to run on change events. */onChange: _pt.func,
  /** Pass additional functionality to run on blur events. */onBlur: _pt.func,
  /** Pass additional functionality to run on focus events. */onFocus: _pt.func,
  /** Pass additional functionality to run for click events on the Clear button. */onClearClicked: _pt.func,
  /** A ref which will be attached to the `<input />` element to manage focus, values, etc. */innerRef: _pt.oneOfType([_pt.string, _pt.func, _pt.object]),
  /** Render optional action buttons inside `<span class="lm-Field-actionButton">` via children. */children: _pt.node
});
// the conceal trigger character is necessary to initiate concealing with asterisks on blur.
// otherwise the 'pipe' function is not called due to the input value not changing on blur.
// the \uFEFF character is a zero-width no-break space, but anything could be used here.
_defineProperty(AlphanumericInput, "concealTrigger", "\uFEFF");
_defineProperty(AlphanumericInput, "masks", {
  claimAndExposure: {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
    concealed: '',
    placeholder: "\u2000\u2000\u2000\u2000\u2000\u2000\u2000\u2000\u2000-\u2000\u2000"
  },
  currency: {
    mask: createNumberMask({
      allowDecimal: true,
      prefix: ''
    }),
    concealed: '',
    placeholder: ''
  },
  date: {
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    concealed: '**/**/****',
    placeholder: 'MM/DD/YYYY'
  },
  dateDMY: {
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    concealed: '**/**/****',
    placeholder: 'DD/MM/YYYY'
  },
  dateMonth: {
    mask: [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    concealed: '**/****',
    placeholder: 'MM/YYYY'
  },
  phone: {
    mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    concealed: '(***) ***-****',
    placeholder: "(\u2000\u2000\u2000) \u2000\u2000\u2000-\u2000\u2000\u2000\u2000"
  },
  ssn: {
    mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    concealed: '***-**-****',
    placeholder: "\u2000\u2000\u2000-\u2000\u2000-\u2000\u2000\u2000\u2000"
  },
  ssnToken: {
    mask: [/\w/, /\w/, /\w/, '-', /\w/, /\w/, '-', /\d/, /\d/, /\d/, /\d/],
    concealed: '***-**-****',
    placeholder: "\u2000\u2000\u2000-\u2000\u2000-\u2000\u2000\u2000\u2000"
  },
  ssnLastFour: {
    mask: [/\d/, /\d/, /\d/, /\d/],
    concealed: '****',
    placeholder: "\u2000\u2000\u2000\u2000"
  },
  creditCard: {
    mask: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
    concealed: "****\u2000****\u2000****\u2000****",
    placeholder: ''
  },
  cvc: {
    mask: [/\d/, /\d/, /\d/],
    concealed: '***',
    placeholder: ''
  },
  zipCode: {
    mask: function mask(rawValue) {
      if (rawValue.length > 5) {
        return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
      return [/\d/, /\d/, /\d/, /\d/, /\d/];
    },
    concealed: '',
    placeholder: ''
  }
});